export default __webpack_public_path__ + "static/1.1_EN-60dc125c5aa01b54c17c4c4c40bfc3ed.png";